// @flow
import {
    ADD_NEW_DASHBOARD_PAGE,
    CANCEL_DASHBOARD_EDIT,
    CHANGE_CURRENT_DASHBOARD_PAGE,
    DASHBOARD_ADD_NEXT_PRODUCT_POSITION,
    DASHBOARD_ADD_PRODUCT,
    DASHBOARD_REMOVE_PRODUCTS,
    DASHBOARD_ADD_PRODUCT_OFF,
    DASHBOARD_ADD_PRODUCT_ON,
    DASHBOARD_EDIT_ON,
    DELETE_CELL,
    DISPLAY_ALL_PRODUCTS,
    GET_DASHBOARD_CUSTOMISATION,
    RECEIVE_DASHBOARD_CUSTOMISATION,
    SAVE_DASHBOARD_EDIT,
    SAVE_DASHBOARD_SUCCESS,
    SHOW_DASHBOARD_DATA,
    UPDATE_CELL_POSITION,
    REDIRECT_TO_POSTINSTALL_GROUPS
} from './constants';

import { createAction } from 'redux-actions';

export const changeCurrentDashboardPage = createAction(CHANGE_CURRENT_DASHBOARD_PAGE);
export const getDashboardCustomisation = createAction(GET_DASHBOARD_CUSTOMISATION);
export const receiveDashboardCustomisation = createAction(RECEIVE_DASHBOARD_CUSTOMISATION);
export const showDashboardData = createAction(SHOW_DASHBOARD_DATA);
export const displayAllProducts = createAction(DISPLAY_ALL_PRODUCTS);
export const dashboardEditOn = createAction(DASHBOARD_EDIT_ON);
export const saveDashboardEdit = createAction(SAVE_DASHBOARD_EDIT);
export const saveDashboardSuccess = createAction(SAVE_DASHBOARD_SUCCESS);
export const cancelDashboardEdit = createAction(CANCEL_DASHBOARD_EDIT);
export const updateCellPosition = createAction(UPDATE_CELL_POSITION);
export const deleteCell = createAction(DELETE_CELL);
export const addNewDashboardPage = createAction(ADD_NEW_DASHBOARD_PAGE);
export const dashboardAddOn = createAction(DASHBOARD_ADD_PRODUCT_ON);
export const dashboardAddOff = createAction(DASHBOARD_ADD_PRODUCT_OFF);
export const dashboardAddProduct = createAction(DASHBOARD_ADD_PRODUCT, (productId, turnEditModeOn = false) => ({
    productId,
    turnEditModeOn
}));
export const dashboardRemoveProducts = createAction(DASHBOARD_REMOVE_PRODUCTS);
export const addNextProductPosition = createAction(DASHBOARD_ADD_NEXT_PRODUCT_POSITION);
export const redirectToPostinstallGroups = createAction(REDIRECT_TO_POSTINSTALL_GROUPS);



// WEBPACK FOOTER //
// ./src/core/state/dashboard/actions.js